import { AsyncButton } from 'components/ButtonNew/Button';
import * as React from 'react';

interface ButtonAuthorizationProps {
  form: string;
  disable?: boolean;
}

const ButtonAuthorization: React.FunctionComponent<ButtonAuthorizationProps> = ({ form, disable }) => {
  return (
        <>
            <AsyncButton
                form={form}
                type="submit"
                variant='contained'
                color='primary'
                style={{ padding: '10px 1rem' }}
                disabled={disable}
            >
                Sambungkan
            </AsyncButton>
        </>
  );
}

export default ButtonAuthorization;